import {
  SharePointParentFolder,
  Permission,
  DSStatus,
} from '@cims-online/shared'
import { useDesignSubmittalLogContext } from '../../../../DesignSubmittalLogContext'
import { CustomRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import {
  useLockRowActionButton,
  useUnlockRowActionButton,
} from 'components/CIMSTable/common/hooks/useLockUnlock'
import { DesignSubmittal } from '../../../../DesignSubmittalLogContext/types'

export function useCustomRowOptions(): CustomRowActionOptions<DesignSubmittal>[] {
  const {
    refetch,
    revertModal: { toggle },
  } = useDesignSubmittalLogContext()
  const { Unlocked, ReturnedToDesignBuilder } = DSStatus
  const lock = useLockRowActionButton<DesignSubmittal>({
    refetch,
    parent: SharePointParentFolder.DesignSubmittals,
    hidden: ({ statusId, deleted }) => deleted || statusId !== Unlocked.id,
  })
  const unlock = useUnlockRowActionButton<DesignSubmittal>({
    refetch,
    parent: SharePointParentFolder.DesignSubmittals,
    hidden: ({ statusId, deleted }) =>
      deleted || statusId !== ReturnedToDesignBuilder.id,
  })
  return [
    {
      text: 'Revert',
      permission: Permission.RevertDesignSubmittal,
      disabled: ({ statusId }) =>
        statusId === DSStatus.ReturnedToDesignBuilder.id
          ? {
              message: `Cannot be reverted while in status: ${DSStatus.ReturnedToDesignBuilder.name}`,
            }
          : false,
      hidden: ({ statusId, deleted }) =>
        deleted ||
        statusId === DSStatus.DisciplineAction.id ||
        statusId === DSStatus.RouterReview.id,
      onClick: (record) => toggle(record),
    },
    lock,
    unlock,
  ]
}
